import { useState } from "react";
import { useQuery } from "convex/react";
import { anyApi } from "convex/server";
import { RentLedger, type RentSummary } from "./RentLedger";

// Landlord-facing rent manager — inline on each lease card in
// /tenants. Defaults collapsed since there can be many months;
// click "Show rent" to expand. Saves vertical space.
export function LeaseRentManager({ leaseId }: { leaseId: string }) {
  const [open, setOpen] = useState(false);
  const summary = useQuery(
    anyApi.rent.listForLease,
    open ? { leaseId } : "skip",
  ) as RentSummary | null | undefined;

  return (
    <div className="mt-3 pt-3 border-t border-slate-100">
      <div className="flex items-center justify-between gap-3">
        <h4 className="text-[10px] font-medium uppercase tracking-[0.2em] text-slate-400">
          Rent
        </h4>
        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          className="rounded-md border border-slate-200 bg-white px-2.5 py-1 text-[11px] font-medium text-slate-700 hover:bg-slate-50 transition-colors"
        >
          {open ? "Hide" : "Show rent"}
        </button>
      </div>
      {open && (
        <div className="mt-2 -mx-5">
          {summary === undefined ? (
            <p className="px-6 py-4 text-sm text-slate-500">Loading…</p>
          ) : (
            <RentLedger summary={summary} />
          )}
        </div>
      )}
    </div>
  );
}
